<template>
  <v-container fluid>
    <v-row>
      <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 4 : 6]">
        <v-img src="https://i.imgur.com/sBgV911.jpg" max-height="80vh" contain></v-img>
      </v-col>
      <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 8 : 6]">
        <v-row justify="center">
          <v-col cols="12">
            <div class="text-h2 text-center">Shaving Roulette</div>
            <div class="text-h4 text-center">Welcome to shaving roulette!</div>
            <div class="text-subtitle-2 text-center">Its time to clean up that sissy clitty and make it as adorable as possible!</div>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn @click="roll">Roll!</v-btn>
          </v-col>
        </v-row>
        <v-row justify="center">
          <RouletteCard
          v-for="card in cards"
          v-bind:rollTitle = "card.rollTitle"
          v-bind:titles = "card.titles"
          v-bind:images = "card.images"
          v-bind:rolled= "card.rolled"
          ></RouletteCard>

        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import RouletteCard from '../../components/RouletteCard';
    import simpleRouletteCardMobile from '../../components/simpleRouletteCardMobile';


    export default {
      name: 'savingRoulette',
      components: {
        RouletteCard,
        simpleRouletteCardMobile
      },
      data: () => ({
        cards:[
          {
            rollTitle: "Style",
            titles: [
              "Heart",
              "Triangle",
              "Landing Strip",
              "Bare",
              "Bikini Line",
              "Natural"
            ],
            images: [
              "https://i.imgur.com/pkvL3xW.png",
              "https://i.imgur.com/00fc6x5.png",
              "https://i.imgur.com/b78ULAp.png",
              "https://i.imgur.com/bOvN9gG.png",
              "https://i.imgur.com/8qCXFaj.png",
              "https://i.imgur.com/G3JSnHd.png"
            ],
            rolled: false
          },
        ]
      }),
      methods: {
        roll() {
          this.cards.forEach(function(card) {
            card.rolled = true;
          });
        }
      },
    }
</script>